module.exports = __webpack_public_path__ + "static/ogre_howdah-0d530d58291ca9abddd1050137145100.png";